/* eslint-disable */

import '@babel/polyfill';
import Vue from 'vue';
import { createApp, h, render } from 'vue';
//import { createVuetify } from 'vuetify'
import store from './store';
import router from './router';
import './plugins/vuetify';
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faUser, faFileAlt, faUnlink, faDatabase } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BlockUI from 'vue-blockui';

import createVuetify from './plugins/vuetify';
import * as Sentry from "@sentry/vue";
//Deprecation Notice: From SDK versions >= 7.47.0 onwards, the @sentry/tracing package is officially deprecated and it has merged into @Sentry/vue.
// import Integrations from "@sentry/browser";
import { AppEnvironments } from './constants';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles'
import mitt from 'mitt';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import JsonExcel from "vue-json-excel3";
import Vue3ConfirmDialog from 'vue3-confirm-dialog';
import 'vue3-confirm-dialog/style';


library.add(faCoffee, faUser, faFileAlt, faUnlink, faDatabase)

//config.productionTip Removed in vue 3
//app.config.productionTip = false;

//var VueTruncate = require('vue-truncate-filter');

const app = createApp(App);

app.use(Vue3ConfirmDialog);
app.component('vue3-confirm-dialog', Vue3ConfirmDialog.default)
app.component("downloadExcel", JsonExcel);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('VueDatePicker', VueDatePicker);
//app.use(VueTruncate);
app.use(BlockUI);
export const agentBus = mitt();
app.config.globalProperties.emitter = agentBus;

Sentry.init({
  app,
  dsn: "https://b22a05d901384fa6bd8302f8108455f3@o335354.ingest.sentry.io/2964230",

  release: `mygrower-salesreview@${process.env.npm_package_version}`,

  replaysOnErrorSampleRate: 1.0,

  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "salesreviewctd.agris.com", "salesreview.agris.com", /^\//]
    }),

    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  tracesSampleRate: 1.0,
  environment: getEnvironment(),

});


app.use(router);
app.use(store);


// const vuetify = createVuetify({
//   components,
//   directives,  

// })

app.use(createVuetify);

app.mount('#app')


function getEnvironment() {
  let url = window.location.host;
  let env = "";
  if (process.env.NODE_ENV === AppEnvironments.Production) {
    if (url.indexOf("salesreviewctd") !== -1)
      env = AppEnvironments.CTD;
    else env = AppEnvironments.Production;
  }
  else if (url.indexOf("localhost") !== -1) {
    env = AppEnvironments.Development
  }
  else env = AppEnvironments.Development;
  return env;
}

// new Vue({
//   vuetify,
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')


